<template>
    <div class="head-info flex align-items">
        <h3>{{ title }}</h3>
        <div class="global-operation">

            <!--简历拜访记录-->
            <template v-if="scenario === 'resumeVisitList'">
                <a-button v-if="check_limit('revisit_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增拜访
                </a-button>
            </template>

            <!--简历-->
            <template v-if="scenario === 'resumeList'">
                <a-button v-if="check_limit('resume_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增简历
                </a-button>
            </template>

            <!--货物库存-->
            <template v-if="scenario === 'psiLogList'">
                <a-button v-if="check_limit('psilog_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增库存
                </a-button>
            </template>

            <!--货物-->
            <template v-if="scenario === 'psiList'">
                <a-button v-if="check_limit('psi_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增货物
                </a-button>
            </template>

            <!--工资-->
            <template v-if="scenario === 'sabillList'">
                <a-button v-if="check_limit('sabill_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增工资账单
                </a-button>
            </template>

            <!--员工管理-->
            <template v-if="scenario === 'employeeList'">
                <a-button v-if="check_limit('employee_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增员工
                </a-button>
                <a-button v-if="check_limit('employee_import')" type="primary" @click="optionFun('import')"><i
                    class="iconfont icon-top_import"></i>导入员工
                </a-button>
            </template>
            <template v-if="scenario === 'employeeContract'">
                <a-button v-if="check_limit('employee_contract_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增员工合同
                </a-button>
            </template>

            <!--职位管理-->
            <template v-if="scenario === 'jobList'">
                <a-button v-if="check_limit('job_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增职位
                </a-button>
            </template>

            <!--企业管理-->
            <template v-if="scenario === 'enterpriseList'">
                <a-button v-if="check_limit('enterprise_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增企业
                </a-button>
            </template>
            <template v-if="scenario === 'enterpriseContract'">
                <a-button v-if="check_limit('enterprise_contract_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增企业合同
                </a-button>
            </template>

            <!--创建员工-->
            <template v-if="scenario === 'accountList'">
                <a-button v-if="check_limit('system_user_info')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增用户
                </a-button>
            </template>
            <!--创建部门-->
            <template v-else-if="scenario === 'roleList'">
                <a-button v-if="check_limit('system_role_info')" type="primary" @click="optionFun('create')"><i
                    class="iconfont icon-add"></i>新增部门
                </a-button>
            </template>
            <!--退出登录-->
            <template v-else-if="scenario === 'center'">
                <a href="javascript:void(0);" class="login-out flex align-items" @click="optionFun('logout')"><i
                    class="iconfont icon-quit"></i>退出登录</a>
            </template>
            <template v-else-if="scenario === 'centerIndex'">
                最后更新时间：{{ timestamp }}
            </template>
        </div>
    </div>
</template>

<script>
import {Icon} from 'ant-design-vue';

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: process.env.VUE_APP_ICONURL,
});
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        scenario: {
            type: [String],
            default: '',
        },
        timestamp: {
            type: String,
            default: '',
        },
        postData: {
            type: Object,
            default: () => {
            }
        },
        operate: {
            type: String,
            default: '1',
        },
    },
    watch: {
        operate(val) {
            this.showOperate = val;
        }
    },
    data() {
        return {
            checkAll: false,// 全选
            indeterminate: false,// 部分选中
            showOperate: this.operate, // 显示页面默认操作按钮
        };
    },
    components: {
        IconFont,
    },
    methods: {
        // 操作
        optionFun(op) {
            this.$emit('optionFun', {scenario: this.scenario, op: op});
        },
    }
}
</script>
